export const FeatureConfig = Symbol.for('FeatureConfig');
